<template>
  <div>
    <button-importation-rejets class="pb-1"/>
    <vue-good-table
        :columns="columnsRejetPrelevement"
        :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: pageLength,
        rowsPerPageLabel: '',
        dropdownAllowAll: false,
        perPageDropdownEnabled: false,
        nextLabel: 'Suivant',
        prevLabel: 'Précédent',
        ofLabel: 'de',
        infoFn: params => ``
      }"
        :rows="rejetPrelevement"
        :rtl="direction"
        :select-options="{
              enabled: false,
              selectOnCheckboxOnly: true,
              selectionInfoClass: 'custom-class',
              selectionText: 'lignes sélectionnées',
              clearSelectionText: 'Effacer la sélection',
              disableSelectInfo: false,
              selectAllByGroup: false
            }"
        style-class="vgt-table condensed"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'actions'">
          <span>
            <b-dropdown dropright no-caret toggle-class="text-decoration-none p-0" variant="link">
              <template v-slot:button-content>
                <feather-icon class="text-body align-middle mr-25" icon="MoreVerticalIcon" size="16"/>
              </template>
              <b-dropdown-item
                  @click="$emit('visualiser-from-rejet-prelevement', {id: props.row.id, date_prelevement: props.row.date, typeInterface: 'Rejet Prelevement'})">
                <feather-icon class="mr-50" icon="SearchIcon"/>
                <span>Visualiser</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <b-row class="mt-2 align-items-center">
          <b-col>
            <b-pagination
                :per-page="pageLength"
                :total-rows="props.total"
                :value="1"
                align="right"
                first-number
                last-number
                next-class="next-item"
                prev-class="prev-item"
                @input="value => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18"/>
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18"/>
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </template>
      <div slot="emptystate" class="text-center align-middle">
        <span>Aucune donn&eacute;e disponible dans le tableau</span>
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BCol,
  BDropdown,
  BDropdownItem,
  BPagination,
  BRow,
  VBToggle,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import ButtonImportationRejets from '@/views/back-office/gestion/gestion-prelevement/rejets/ButtonImportationRejets.vue';

export default {
  components: {
    ButtonImportationRejets,
    BCol,
    BDropdown,
    BDropdownItem,
    BPagination,
    BRow,
    VueGoodTable
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  props: {
    propChildRejetPrelevement: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      rejetPrelevement: [],
      pageLength: 10,
      dir: false,
      columnsRejetPrelevement: [
        {
          label: 'ID',
          field: 'id',
          sortable: false,
          thClass: 'text-center align-middle bg-primary text-white unbreaking h6',
          tdClass: 'text-center m-0 p-2 align-middle h6'
        },
        {
          label: 'Date',
          field: 'date',
          type: 'date',
          dateInputFormat: 'dd/MM/yyyy',
          dateOutputFormat: 'dd/MM/yyyy',
          formatFn(value) { return value != null ? value : null },
          sortable: false,
          thClass: 'text-center align-middle bg-primary text-white unbreaking h6',
          tdClass: 'text-center m-0 p-2 align-middle h6'
        },
        {
          field: 'actions',
          label: 'Actions',
          sortable: false,
          thClass: 'text-center align-middle bg-primary text-white unbreaking h6',
          tdClass: 'text-center m-0 py-1 px-2 align-middle'
        }
      ],
    }
  },
  watch: {
    propChildRejetPrelevement: {
      immediate: true,
      deep: true,
      handler(val) {
        this.rejetPrelevement = val
      }
    },
  },
}
</script>

<style scoped>

</style>